window.Backbone = require 'backbone'
window.Backbone.$ = window.$
require('../../modules/support/frontend/support')
require "./vendor_modules/jQuery/jQuery-ui-1.10.1.min.js"
require "./vendor_modules/jQuery/datetimepicker.js"
require "./vendor_modules/jQuery/pagination/jQuery-pagination-2.2.js"
require "./vendor_modules/mustache-0.7.2.js"

